import { withStyles } from '@material-ui/core/styles'
import React from 'react'

import { Dropzone } from '../../../../../../../Components/Form/Dropzone'
import styles from './styles'

const DropZoneArea = ({
  acceptedFormats,
  classes,
  error,
  onFileUpload,
  setFile,
  setError,
  hint,
  errorMessage,
}) => {
  return (
    <div>
      <Dropzone
        accept={acceptedFormats || '.csv'}
        hint={hint}
        activeClassName="dropzoneActive"
        className={classes.dropzone}
        multiple={false}
        showImagePreview={false}
        input={{
          value: '',
          onChange: onFileUpload,
        }}
        disabled={false}
        onDropRejected={(rejectedFiles, errors, other) => {
          setFile(null)
          setError(
            errorMessage ||
              'File format not supported. Please try with a different file.',
          )
        }}
      />
      {error ? <div className={classes.validationError}>{error}</div> : null}
    </div>
  )
}

export default withStyles(styles)(DropZoneArea)
